import { createContext, useContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types'
const ActifContext = createContext();

export const ActifProvider = ({ children }) => {
    const [actifs, setActifs] = useState([]);
    const [selectedActif, setSelectedActif] = useState({});
  
    const setActifAttributes = (attributes) => {
      // Merge the new attributes with the existing ones
      // setActif((prevActif) => ({ ...prevActif, ...attributes }));
      setActifs(attributes.actifs || []);
    };
    // utilisation de useMemo pour mémoriser l'objet 'value'
    const value=useMemo(()=>({
      actifs, 
      setActifs,
      setActifAttributes ,
      setSelectedActif , 
       selectedActif

    }),[actifs,selectedActif])
  
    return (
      <ActifContext.Provider value={ value }>
        {children}
      </ActifContext.Provider>
    );
  };
  ActifProvider.propTypes={
    children:PropTypes.node.isRequired,
  }
  
  export const useActif = () => {
    return useContext(ActifContext);
  };